import { Form, Typography } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"

import type { CustomerMutateData } from "../../types/customer.types.ts"

const { Title } = Typography

interface CustomerFormHeaderProps {
  isEdit: boolean
  form: FormInstance<CustomerMutateData>
}

export function CustomerFormHeader({ isEdit, form }: CustomerFormHeaderProps) {
  const isInvite = Form.useWatch("is_invite", { form })

  const title = (() => {
    if (isEdit) return "Edit Customer"
    return isInvite ? "Invite Customer" : "Add Customer"
  })()

  return (
    <Title level={3} style={{ textAlign: "left" }}>
      {title}
    </Title>
  )
}
